module.exports = __webpack_public_path__ + "static/media/connect-off-app-provider-icon.d948c715.svg";